<template>
  <div>
    <div v-if="view.type === 'dayGridWeek'">
      <i class="fa fa-briefcase pr-1"/>
      <span v-text="$t(`entities.activity_types.${event.activity.id}`)" class="is-bold"></span>
    </div>
    <div>
      <i class="fa fa-clock-o pr-1"/>
      {{ $options.filters.localTime(event.start, 'HH:mm')}} - {{ $options.filters.localTime(event.end, 'HH:mm')}}
    </div>
    <div>
      <i class="fa fa-user pr-1"/>
      <span class="is-bold">{{event.person.firstName}} {{event.person.lastName}}</span>
    </div>
    <div v-if="event.person && event.person.mobilePhone && view.type === 'dayGridWeek'">
      <i class="fa fa-phone pr-1"/>
      <span v-text="event.person.mobilePhone"></span>
    </div>
    <div >
      <i class="fa fa-home pr-1"/>
      <span v-text="event.facility.name"></span>
    </div>
    <div v-if="event.originFacility.id !== event.facility.id">
      <i class="fa fa-exchange pr-1"/>
      <span v-text="event.originFacility.name"></span>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    view: {
      type: Object,
      required: true
    },
    event: {
      type: Object,
      required: true
    }
  },
  mounted: function () {
  },
  computed: {
  }
};
</script>

